<!-- <div class="footer-background" *ngIf="isLogin">
    <div class="box1" routerLink="/mobile/mobileview" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"> 
        <img class="icon" src="../../../assets/Chart.png" alt="">
        <p class="live-rates-para">Home</p>
    </div>
    <div class="box1" routerLink="/mobile/orders" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <img class="icon" src="../../../assets/Bookmark.png" alt="">
        <p class="live-rates-para">My Orders</p>
    </div>

     <div class="box1" routerLink="/mobile/orders" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <img class="icon" src="../../../assets/Bookmark.png" alt="">
        <p class="live-rates-para">Coin Orders</p>
    </div>

    <div class="box1" routerLink="/mobile/menu" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <img class="icon" src="../../../assets/Category.png" alt="">
        <p class="live-rates-para">Menu</p>
    </div>
    <div class="box1" routerLink="/mobile/profile" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <img class="icon" src="../../../assets/Profile.png" alt="">
        <p class="live-rates-para">Profile</p>
    </div>
</div> -->


<div class="footer-background" *ngIf="isLogin">

  <!-- Home -->
  <div
    class="box1"
    routerLink="/mobile/mobileview"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">

    <img class="icon" src="../../../assets/Chart.png" alt="">
    <p class="live-rates-para">Home</p>
  </div>


  <!-- My Orders -->
  <div
    class="box1"
    [routerLink]="['/mobile/orders']"
    [queryParams]="{ orderType: 'Orders' }"
    routerLinkActive="active">

    <img class="icon" src="../../../assets/Bookmark.png" alt="">
    <p class="live-rates-para">My Orders</p>
  </div>


  <!-- Coin Orders -->
  <div
    class="box1"
    [routerLink]="['/mobile/orders']"
    [queryParams]="{ orderType: 'Coins' }"
    routerLinkActive="active">

    <img class="icon" src="../../../assets/Bookmark.png" alt="">
    <p class="live-rates-para">Coin Orders</p>
  </div>


  <!-- Menu -->
  <div
    class="box1"
    routerLink="/mobile/menu"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">

    <img class="icon" src="../../../assets/Category.png" alt="">
    <p class="live-rates-para">Menu</p>
  </div>


  <!-- Profile -->
  <div
    class="box1"
    routerLink="/mobile/profile"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">

    <img class="icon" src="../../../assets/Profile.png" alt="">
    <p class="live-rates-para">Profile</p>
  </div>

</div>